<template>
  <header class="header">
    <h3 @click="fakeDecreaseNumber">
      <span>Directa</span>
      <span class="important">MES</span>
    </h3>
    <p class="version">
      <span>1.00.02</span>
    </p>
    <h2 class="title" @click="fakeChangeDisplay">{{ title }}</h2>
    <h3 class="empresa" @click="fakeIncreaseNumber">{{ $store.state.empresa }}</h3>
    <p class="date">
      <span>{{ date.toLocaleDateString() }}</span>
      <span>{{ $store.state.date }}</span>
    </p>
  </header>
</template>

<script>
export default {
  name: "Header",
  data: () => ({
    date: new Date(),
    title: ""
  }),
  mounted() {
    setInterval(() => (this.date = new Date()), 60000);
    this.title = this.getTitle();
  },
  computed: {},
  methods: {
    fakeChangeDisplay() {
      if (!this.$store.state.fake) return;
      const pathname = this.$router.currentRoute.name;
      if (pathname.includes("disponibilidade"))
        this.$router.push({ name: "qualidadeum" });
      else if (pathname.includes("qualidade"))
        this.$router.push({ name: "oeeum" });
      else this.$router.push({ name: "disponibilidadeum" });
      this.title = this.getTitle();
    },
    fakeIncreaseNumber() {
      if (!this.$store.state.fake) return;
      // eslint-disable-next-line no-unused-vars
      const path = this.$router.currentRoute.name;
      let pathname = "";

      if (path.includes("disponibilidade")) pathname = "disponibilidade";
      else if (path.includes("qualidade")) pathname = "qualidade";
      else pathname = "oee";

      if (path.includes("um")) {
        this.$router.push({ name: pathname + "dois" });
      } else if (path.includes("dois")) {
        this.$router.push({ name: pathname + "quatro" });
      } else if (path.includes("quatro")) {
        this.$router.push({ name: pathname + "oito" });
      } else if (path.includes("oito")) {
        this.$router.push({ name: pathname + "doze" });
      } else if (path.includes("doze")) {
        this.$router.push({ name: pathname + "info" });
      } else {
        this.$router.push({ name: pathname + "um" });
      }
    },
    fakeDecreaseNumber() {
      if (!this.$store.state.fake) return;
      // eslint-disable-next-line no-unused-vars
      const path = this.$router.currentRoute.name;
      let pathname = "";

      if (path.includes("disponibilidade")) pathname = "disponibilidade";
      else if (path.includes("qualidade")) pathname = "qualidade";
      else pathname = "oee";

      if (path.includes("um")) {
        this.$router.push({ name: pathname + "info" });
      } else if (path.includes("dois")) {
        this.$router.push({ name: pathname + "um" });
      } else if (path.includes("quatro")) {
        this.$router.push({ name: pathname + "dois" });
      } else if (path.includes("oito")) {
        this.$router.push({ name: pathname + "quatro" });
      } else if (path.includes("doze")) {
        this.$router.push({ name: pathname + "oito" });
      } else {
        this.$router.push({ name: pathname + "doze" });
      }
    },
    getTitle() {
      const pathname = this.$router.currentRoute.name;
      if (pathname.includes("disponibilidade")) return "Disponibilidade";
      if (pathname.includes("qualidade")) return "Qualidade";
      if (pathname.includes("info")) return "Informações";
      return "OEE";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  width: 100%;
  background: #263238;
  background: var(--color-secondary);
  height: 7rem;
  height: var(--header-height);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2%;
  position: relative;
}

h3 {
  font-size: 2.5rem;
}

h3 .important {
  font-size: 3rem;
}

.title {
  font-size: 5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.version {
  position: absolute;
  bottom: 1px;
  left: 2%;
  font-size: 1.6rem;
}

.date {
  flex: 0;
  position: absolute;
  bottom: 1px;
  right: 2%;
  font-size: 1.6rem;
}

.date span:first-child {
  margin-right: 1rem;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .empresa {
    position: absolute;
    right: 3.5rem;
    top: 30%;
  }
}
</style>
